import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import {
  DeliveryChallanInfo,
  DeliveryLineItemInfo,
} from "../../../SchemaInfo/info";
import { DeliveryChallanSchema } from "../../../Schemas/purchase/delivery_challan.schema";
import { getId, toTitleCase } from "../../../Components/Functions/word.fun";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { roundOffCost } from "../../../Components/Functions/amt.fun";

const AddDeliveyChallan = () => {
  let userData = useSelector((store) => store?.login?.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [data, setData] = useState([]);
  const location = useLocation();
  const [dcData, setDcData] = useState(DeliveryChallanInfo);
  const [listNum, setListNum] = useState([]);
  const [currentInventoryData, setCurrentInventoryData] = useState([]);
  const [pendingDcData, setPendingDcData] = useState([]);

  const [materialData, setMaterialData] = useState([]);
  const [hydrponicType, setHydrponicType] = useState();
  const [totalCount, setTotalCount] = useState([]);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.MaterialList);
          setTotalCount(res?.data?.consolidatedList);
          setCurrentInventoryData(res?.data?.MaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  // useEffect(() => {
  //   setLoading(true);
  //   performRequest("GET", `/materialPlanning/getAllMaterialList`)
  //     .then((res) => {
  //       if (res.status === 200) {

  //       } else {
  //         Toast("error", "Error while getting PO!");
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);

  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/materialPlanning/getAllMaterialList`)
      .then((res) => {
        if (res.status === 200) {
          setCurrentInventoryData(res?.data?.MaterialList);
          setPendingDcData(res?.data?.consolidatedList);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/get-all-hm-lists")
      .then((res) => {
        if (res.status === 201) {
          setListNum(res.data?.allMaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryId = searchParams.get("duplicate");
    const today = new Date();

    if (queryId) {
      setLoading(true);
      performRequest("GET", `/deliveryChallan/getDcById/${queryId}`)
        .then((res) => {
          if (res.status === 200) {
            let { dcNumber, ...data } = res.data.dcStatus;
            data = {
              ...data,
              isApproved: false,
              lineItems: data.lineItems || [],
            };
            setDcData(data);
            setMaterialData(res?.data?.materialData?.materialList);
            setHydrponicType(res?.data?.materialData?.hydroponicType);
          } else {
            Toast("error", "Error while getting PO!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [location.search]);

  const handelSubmit = (values) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });

    values = {
      ...values,
      cusClientName: toTitleCase(values.cusClientName),
      driverName: toTitleCase(values.driverName),
      transportName: toTitleCase(values.transportName),
    };

    setLoading(true);
    performRequest("POST", "/deliveryChallan/createDc", {
      ...values,
      generatedBy: userData.Name,
    })
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "DC created successfully!");
          navigate(`/delivery-challan`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const handleListNumChange = async (e, props) => {
    const selectedNum = e.target.value;

    // Update Formik value
    props.setFieldValue("materilListNum", selectedNum);

    if (!selectedNum) {
      setMaterialData([]);
      return;
    }
    performRequest(
      "GET",
      `/materialPlanning/getMaterialByListNum/${selectedNum}`
    )
      .then((res) => {
        if (res.status === 200) {
          setMaterialData(res.data?.materialList);
          setHydrponicType(res.data?.hydroponicType);
        } else {
          Toast("error", "Error while getting Lead!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const checkTouched = (obj) => {
    if (
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  if (loading) {
    return <LoadingPage />;
  }

  const getPrice = (inStock, costperUnit, weight, unit) => {
    const weightNew = parseFloat(weight);

    // if weight is a valid number > 0 and unit is among the specified ones, calculate with weight
    if (
      (unit === "kg" ||
        unit === "grams" ||
        unit === "ltr" ||
        unit === "ml" ||
        unit === "mtr") &&
      !isNaN(weightNew) &&
      weightNew > 0
    ) {
      return weightNew * costperUnit * inStock;
    }

    // fallback if weight is missing or 0
    return costperUnit * inStock;
  };

  const handleQuantityChange = (e, index, props) => {
    const { setFieldValue } = props;

    const sku = props.values.lineItems[index]?.sku;
    let itemFrom = props.values.lineItems[index]?.itemFrom;

    const value = e.target.value;

    if (itemFrom === "custom") {
      setFieldValue(`lineItems[${index}].itemQuantity`, value);
      return;
    }

    if (!/^\d*$/.test(value)) return;

    // ✅ FIRST: set value so user sees full number
    setFieldValue(`lineItems[${index}].itemQuantity`, value);

    let enteredQty = Number(value || 0);
    let stock =
      currentInventoryData.find((inv) => inv.sku === sku)?.inStock || 0;

    if (pendingDcData) {
      let pendingCount =
        pendingDcData.find((inv) => inv.sku === sku)?.totalRequired || 0;
      enteredQty = enteredQty + pendingCount;
    }

    if (enteredQty > stock) {
      setTimeout(() => {
        const confirmResult = window.confirm(
          `Please update stock first. Short by ${enteredQty - stock}`
        );
        // 🔁 If user clicks OK or Cancel → reset field
        if (confirmResult === true || confirmResult === false) {
          setFieldValue(`lineItems[${index}].itemQuantity`, "");
        }
      }, 0);
    } else {
      setFieldValue(`lineItems[${index}].itemQuantity`, value);
    }
  };

  const totalCountArray = Array.isArray(totalCount)
    ? totalCount
    : Object.values(totalCount);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Delivery Challan</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">New Delivery Challan</h2>
            </div>
            <Formik
              initialValues={dcData}
              validationSchema={DeliveryChallanSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Project</label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="project">
                          <option value="">Select</option>
                          {projects &&
                            projects?.map((pro) => {
                              return (
                                <option
                                  key={pro.cpNumber}
                                  value={getId(pro.cpNumber)}
                                >
                                  {pro.clientName}
                                </option>
                              );
                            })}
                        </CustomSelect>

                        {props.touched.project && props.errors.project && (
                          <p className="text-danger">{props.errors.project}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Custom Client Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="cusClientName" />

                        {props.touched.cusClientName &&
                          props.errors.cusClientName && (
                            <p className="text-danger">
                              {props.errors.cusClientName}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Material List Number
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          type="text"
                          name="materilListNum"
                          onChange={(e) => handleListNumChange(e, props)}
                        >
                          <option value="">Select</option>
                          {listNum &&
                            listNum?.map((pro) => {
                              return (
                                <option
                                  key={pro?.uniqueNum}
                                  value={pro?.uniqueNum}
                                >
                                  {pro?.uniqueNum}
                                </option>
                              );
                            })}
                        </CustomSelect>

                        {props.touched.materilListNum &&
                          props.errors.materilListNum && (
                            <p className="text-danger">
                              {props.errors.materilListNum}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Country of supply
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="countryOfSupply">
                          <option value="">Select Country</option>
                          <option value="india">India</option>
                        </CustomSelect>

                        {props.touched.countryOfSupply &&
                          props.errors.countryOfSupply && (
                            <p className="text-danger">
                              {props.errors.countryOfSupply}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Place of supply
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="placeOfSupply" />

                        {props.touched.placeOfSupply &&
                          props.errors.placeOfSupply && (
                            <p className="text-danger">
                              {props.errors.placeOfSupply}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Challan date
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="date" name="challanDate" />

                        {props.touched.challanDate &&
                          props.errors.challanDate && (
                            <p className="text-danger">
                              {props.errors.challanDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Lr number</label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="lrNumber" />

                        {props.touched.lrNumber && props.errors.lrNumber && (
                          <p className="text-danger">{props.errors.lrNumber}</p>
                        )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Eway bill number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="ewayBillNumber" />

                        {props.touched.ewayBillNumber &&
                          props.errors.ewayBillNumber && (
                            <p className="text-danger">
                              {props.errors.ewayBillNumber}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Transport name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="transportName" />

                        {props.touched.transportName &&
                          props.errors.transportName && (
                            <p className="text-danger">
                              {props.errors.transportName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vehicle number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="vehicleNumber" />

                        {props.touched.vehicleNumber &&
                          props.errors.vehicleNumber && (
                            <p className="text-danger">
                              {props.errors.vehicleNumber}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Driver name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="driverName" />

                        {props.touched.driverName &&
                          props.errors.driverName && (
                            <p className="text-danger">
                              {props.errors.driverName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Driver phone number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="driverPhoneNumber" />

                        {props.touched.driverPhoneNumber &&
                          props.errors.driverPhoneNumber && (
                            <p className="text-danger">
                              {props.errors.driverPhoneNumber}
                            </p>
                          )}
                      </div>
                    </div>

                    {props.values?.materilListNum && (
                      <hr className="m-0 p-0"></hr>
                    )}
                    {props.values?.materilListNum && (
                      <h2 className="mt-2">Material List : {hydrponicType}</h2>
                    )}
                    {props.values?.materilListNum && <hr></hr>}
                    {props.values?.materilListNum && (
                      <div className="col-lg-12 col-md-12">
                        <div className="table-responsive">
                          <table className="table table-vcenter w-100 border">
                            <thead>
                              <tr>
                                <th style={{ minWidth: "150px" }}>
                                  Sr/ HSN/ Image
                                </th>
                                <th style={{ minWidth: "170px" }}>
                                  ITEM /SKU/ Weight/ Formula
                                </th>
                                <th style={{ minWidth: "200px" }}>
                                  Specifications
                                </th>
                                <th>In stock / Count / Price</th>
                              </tr>
                            </thead>

                            <tbody>
                              {materialData
                                ?.filter((item) => item?.count)
                                .map((item, index) => {
                                  const specialSkus = [
                                    "MAT-CEA-FLA-FOG-GRO-00042",
                                    "MAT-GRB-00081",
                                  ];

                                  const totalCount = specialSkus.includes(
                                    item?.sku
                                  )
                                    ? item?.countGrow || 0
                                    : (item?.countFlat || 0) +
                                      (item?.countGrow || 0);

                                  return (
                                    <tr
                                      key={index}
                                      // style={{
                                      //   backgroundColor:
                                      //     Number(item.count) >
                                      //     Number(
                                      //       currentInventoryData.find(
                                      //         (inv) => inv.sku === item.sku
                                      //       )?.inStock || 0
                                      //     )
                                      //       ? "#ffcccc"
                                      //       : "transparent",
                                      // }}

                                      style={{
                                        backgroundColor: (() => {
                                          const inventoryStock = Number(
                                            currentInventoryData.find(
                                              (inv) => inv.sku === item.sku
                                            )?.inStock || 0
                                          );

                                          // Special case: Growbag SKU + hydrophonicsOly type
                                          if (
                                            item.sku ===
                                              "MAT-CEA-FLA-FOG-GRO-00042" &&
                                            hydrponicType === "hydroponicsOnly"
                                          ) {
                                            return Number(item.countGrow) >
                                              inventoryStock
                                              ? "#ffcccc"
                                              : "transparent";
                                          }

                                          // Default behavior
                                          return Number(item.count) >
                                            inventoryStock
                                            ? "#ffcccc"
                                            : "transparent";
                                        })(),
                                      }}
                                    >
                                      {/* Column 1 */}
                                      <td>
                                        <img
                                          src={item?.image}
                                          alt={item?.item}
                                          width="150"
                                          height="150"
                                          className="m-0 mt-1 mb-1"
                                          style={{ borderRadius: "8px" }}
                                        />
                                        <br />
                                        <span className="me-1">
                                          {index + 1}.
                                        </span>
                                        {item?.hsn && (
                                          <span className="fs-5">
                                            <b>HSN: {item?.hsn}</b>
                                          </span>
                                        )}
                                      </td>

                                      {/* Column 2 */}
                                      <td>
                                        <span className="fs-5">
                                          {item?.item}
                                        </span>
                                        <br />
                                        <b>SKU : {item?.sku}</b>

                                        {item?.weight && (
                                          <>
                                            <br />
                                            <b>
                                              Weight : {item?.weight}{" "}
                                              {item?.proUnit}
                                            </b>
                                          </>
                                        )}

                                        {item?.formula && (
                                          <>
                                            <br />
                                            <b>Formula : {item?.formula}</b>
                                          </>
                                        )}

                                        {item?.flatFormul && (
                                          <>
                                            <br />
                                            <b>Formula : {item?.flatFormul}</b>
                                          </>
                                        )}

                                        {item?.mergeType && (
                                          <>
                                            <br />
                                            <b>
                                              Available in : {item?.mergeType}
                                            </b>
                                          </>
                                        )}

                                        {(item?.countFlat ||
                                          item?.countGrow) && (
                                          <>
                                            <br />
                                            <b>
                                              Flatbed Count :{" "}
                                              {item?.countFlat || "0"}
                                              {item?.unit}
                                            </b>
                                            <br />
                                            <b>
                                              Growbags Count :{" "}
                                              {item?.countGrow || "0"}
                                              {item?.unit}
                                            </b>
                                            <hr className="p-0 m-1" />
                                            <b>
                                              Total Count : {totalCount}
                                              {item?.unit}
                                            </b>
                                          </>
                                        )}
                                      </td>

                                      {/* Column 3 */}
                                      <td className="fs-5">
                                        {item?.specificationsNew?.length
                                          ? [
                                              ...new Map(
                                                item.specificationsNew
                                                  .filter(
                                                    (spec) =>
                                                      (hydrponicType ===
                                                        "cea-nvph" &&
                                                        spec?.type === "cea") ||
                                                      hydrponicType ===
                                                        spec?.type ||
                                                      (hydrponicType ===
                                                        "hydroponicsOnly" &&
                                                        (spec?.type ===
                                                          "flatbed" ||
                                                          spec?.type ===
                                                            "growbags"))
                                                  )
                                                  .map((spec) => [
                                                    spec?.specification,
                                                    spec,
                                                  ])
                                              ).values(),
                                            ].map((spec, i) => (
                                              <div key={i}>
                                                {spec?.specification}
                                              </div>
                                            ))
                                          : "N/A"}
                                        <br className="m-0 p-0"></br>
                                        {item?.brandName && (
                                          <p className="m-0 badge bg-green-lt">
                                            Brand Name: {item?.brandName}
                                          </p>
                                        )}
                                        <br className="m-0 p-0"></br>

                                        {totalCountArray?.length > 0 && (
                                          <>
                                            <hr className="mb-1 mt-0 p-0"></hr>
                                            <h4 className="m-0 fw-bold">
                                              Total Stock For DC Approval :
                                            </h4>
                                            <div>
                                              <span className="fs-2">
                                                <b>
                                                  {totalCountArray.find(
                                                    (inv) =>
                                                      inv.sku === item.sku
                                                  )?.totalRequired ?? 0}
                                                  {totalCountArray.find(
                                                    (inv) =>
                                                      inv.sku === item.sku
                                                  )
                                                    ? item?.unit
                                                    : ""}
                                                </b>
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </td>

                                      {/* Column 4 */}
                                      <td style={{ width: "120px" }}>
                                        <span className="fs-3">
                                          <b>
                                            Count :{" "}
                                            {[
                                              "MAT-CEA-FLA-FOG-GRO-00042",
                                              "MAT-GRB-00081",
                                            ].includes(item?.sku) &&
                                            hydrponicType === "hydroponicsOnly"
                                              ? item?.countGrow || 0
                                              : item?.count || 0}
                                            {item?.unit || "N/A"}
                                            <span>
                                              {item?.countKg
                                                ? ` / ${item?.countKg}kg`
                                                : ""}
                                            </span>
                                          </b>
                                        </span>
                                        <hr className="m-1" />
                                        <b>
                                          In Stock :{" "}
                                          {Number(
                                            currentInventoryData.find(
                                              (inv) => inv.sku === item.sku
                                            )?.inStock || 0
                                          )}
                                        </b>
                                        <hr className="m-1" />
                                        <b>
                                          Cost/Unit : {roundOffCost(item?.cost)}
                                        </b>
                                        <hr className="m-1" />
                                        <b>
                                          Total :
                                          {roundOffCost(
                                            getPrice(
                                              item?.count,
                                              item?.cost,
                                              item?.weight,
                                              item?.proUnit
                                            )
                                          )}
                                        </b>
                                      </td>
                                    </tr>
                                  );
                                })}

                              {/* ✅ Fixed Total Row */}
                              <tr>
                                <td
                                  colSpan="3"
                                  className="text-end fw-bold fs-4"
                                >
                                  Total Cost:
                                </td>
                                {/* <td className="fw-bold fs-4">
                                  {roundOffCost(
                                    materialData?.reduce(
                                      (acc, item) =>
                                        acc + (item?.count * item?.cost || 0),
                                      0
                                    )
                                  )}
                                </td> */}
                                <td className="fw-bold fs-4">
                                  {roundOffCost(
                                    materialData?.reduce(
                                      (acc, item) =>
                                        acc +
                                        (getPrice(
                                          item?.count,
                                          item?.cost,
                                          item?.weight,
                                          item?.proUnit
                                        ) || 0),
                                      0
                                    )
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    <hr />
                    <h3>Line Items :</h3>
                    <hr />
                    <FieldArray name="lineItems">
                      {({ push, remove }) => (
                        <div>
                          {props.values?.lineItems?.map((lineItem, index) => (
                            <div key={index}>
                              <div className="row g-3 align-items-center">
                                {props?.values?.lineItems?.[index]?.itemFrom !==
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">
                                      Particulars:
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                      />
                                    </div>
                                  </div>
                                )}
                                {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Particulars
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                        value={
                                          props?.values?.lineItems?.[index]?.id
                                        }
                                        onChange={(e) => {
                                          let item = data?.find(
                                            (el) => el.id == e.target.value
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].particulars`,
                                            item?.item
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].id`,
                                            item?.id
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].hsn`,
                                            item?.hsn
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemUnit`,
                                            item?.unit
                                          );
                                          // ✅ ADD THIS FOR SKU
                                          props.setFieldValue(
                                            `lineItems[${index}].sku`,
                                            item?.sku
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {data?.map((el) => {
                                          return (
                                            <option key={el.id} value={el?.id}>
                                              {el?.item}
                                            </option>
                                          );
                                        })}
                                      </CustomSelect>
                                    </div>
                                  </div>
                                )}

                                {/* {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">HSN:</label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].hsn`}
                                      />
                                    </div>
                                  </div>
                                )} */}
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item units
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name={`lineItems[${index}].itemUnit`}
                                    >
                                      <option value="">Select</option>
                                      <option value="nos">Nos</option>
                                      <option value="kg">Kg</option>
                                      <option value="grams">Grams</option>
                                      <option value="ltr">Litter</option>
                                      <option value="ml">ML</option>
                                      <option value="packs">Packs</option>
                                      <option value="pair">Pair</option>
                                      <option value="sqm">SqM</option>
                                      <option value="sqft">SqFt</option>
                                      <option value="mts">Meters</option>
                                      <option value="pcs">Pices</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item quantity
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].itemQuantity`}
                                      onChange={(e) =>
                                        handleQuantityChange(e, index, props)
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-md">
                                  <button
                                    className="col-3 btn btn-primary mt-4"
                                    style={{
                                      width: "70px",
                                      height: "30px",
                                    }}
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>

                              <hr />
                            </div>
                          ))}

                          <button
                            className="btn btn-primary mt-2 me-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push(DeliveryLineItemInfo);
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push(DeliveryLineItemInfo);
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Inventory Item
                          </button>
                          <button
                            className="btn btn-primary mt-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...DeliveryLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...DeliveryLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Custom Line Item
                          </button>
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create Delivery Challan" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default AddDeliveyChallan;
